import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 py-12 border-t border-slate-800 pb-24 md:pb-12" data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12" data-id="element-86">
          {/* Brand Col */}
          <div className="md:col-span-5 lg:col-span-4" data-id="element-87">
            <div className="mb-6" data-id="element-88">
              <img src="https://lynjoneslogistics.com/wp-content/uploads/lynjones-logistics-Final.png" alt="LynJones Logistics" className="h-14 w-auto object-contain bg-white rounded-lg p-2" data-id="element-89" />
            </div>
            <p className="text-sm text-slate-400 mb-6 leading-relaxed" data-id="element-90">
              Nationwide RV transport and motorhome shipping specialists. Fully
              licensed, bonded, and insured for your complete peace of mind.
            </p>
            <div className="space-y-3" data-id="element-91">
              <a href="tel:+17543251100" className="flex items-center gap-3 text-sm hover:text-white transition-colors" data-id="element-92">
                <Phone className="w-4 h-4 text-brand-red" data-id="element-93" />
                (754) 325-1100
              </a>
              <div className="flex items-center gap-3 text-sm" data-id="element-94">
                <Mail className="w-4 h-4 text-brand-red" data-id="element-95" />
                quotes@lynjoneslogistics.com
              </div>
              <div className="flex items-center gap-3 text-sm" data-id="element-96">
                <MapPin className="w-4 h-4 text-brand-red" data-id="element-97" />
                Serving all 50 US States
              </div>
            </div>
          </div>

          {/* Services Col */}
          <div className="md:col-span-4 lg:col-span-4" data-id="element-98">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-99">
              Our Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-100">
              <li data-id="element-101">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-102">
                  RV Transport
                </a>
              </li>
              <li data-id="element-103">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-104">
                  Motorhome Shipping
                </a>
              </li>
              <li data-id="element-105">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-106">
                  Travel Trailer Hauling
                </a>
              </li>
              <li data-id="element-107">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-108">
                  Cross-Country RV Movers
                </a>
              </li>
              <li data-id="element-109">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-110">
                  Oversized RV Transport
                </a>
              </li>
            </ul>
          </div>

          {/* Legal/Trust Col */}
          <div className="md:col-span-3 lg:col-span-4" data-id="element-111">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-112">
              Company
            </h4>
            <ul className="space-y-3 text-sm mb-6" data-id="element-113">
              <li data-id="element-114">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-115">
                  About Us
                </a>
              </li>
              <li data-id="element-116">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-117">
                  Contact
                </a>
              </li>
              <li data-id="element-118">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-119">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-120">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-121">
                  Terms of Service
                </a>
              </li>
            </ul>
            <div className="bg-slate-800 p-4 rounded-lg border border-slate-700 inline-block" data-id="element-122">
              <p className="text-xs font-semibold text-white mb-1" data-id="element-123">
                DOT Registered
              </p>
              <p className="text-xs text-slate-400" data-id="element-124">
                MC #1234567 • USDOT #7654321
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-125">
          <p className="text-xs text-slate-500 text-center md:text-left" data-id="element-126">
            &copy; {new Date().getFullYear()} LynJones Logistics. All rights
            reserved.
          </p>
          <p className="text-xs text-slate-500 text-center md:text-right" data-id="element-127">
            Designed for secure and reliable RV hauling nationwide.
          </p>
        </div>
      </div>
    </footer>;
}